import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getEndorsementEntryData, getEndorsementExpiryData, setEndorsementEntryData, setEndorsementExpiryData } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function TemplateFooterSection() {
  const entryDate = useSelector(getEndorsementEntryData)
  const expiryDate = useSelector(getEndorsementExpiryData)
  const user = useSelector(getUser)
  const dispatch = useDispatch()
  return (
    <div className="col-12 my-2">
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <label className="form-label">{user?.role === ROLES.STUDENT ? "Student" : "Instructor"}</label>
          <input
            type="text"
            className="form-control"
            value={user?.firstname + " " + user?.lastname}
            disabled
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <label className="form-label">Date of endorsement</label>
          <input type="date" className="form-control" value={entryDate} onChange={(e) => dispatch(setEndorsementEntryData(e.target.value))} />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <label className="form-label">Expiration</label>
          <input type="date" className="form-control" value={expiryDate} onChange={(e) => dispatch(setEndorsementExpiryData(e.target.value))} />
        </div>
      </div>
      <div className="col-12">
        <p className="mt-3">
          Don't see a template you need?
          <Link to="#">Let us know what we should add.</Link>
        </p>
      </div>
      {/* <div className="d-flex justify-content-end">
        <button className="button">Add Endorsement</button>
      </div> */}
    </div>
  );
}

export default TemplateFooterSection;
